import { render, staticRenderFns } from "./StudentProgressOverview.vue?vue&type=template&id=56713720"
import script from "./StudentProgressOverview.vue?vue&type=script&lang=js"
export * from "./StudentProgressOverview.vue?vue&type=script&lang=js"
import style0 from "./StudentProgressOverview.vue?vue&type=style&index=0&id=56713720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports